
export const adminStyles = theme => ({

    registerContainer: {
        overflow: 'scroll',
        height: 'auto',
        width: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        padding: '2% 0',
        backgroundColor: theme.palette.darkBlue
    },
    verifyContainer: {

    },
    dialogHeading: {
        fontSize: '16px',
        fontWeight: '700',
        color: theme.palette.white
    },
    button: {
        backgroundColor: theme.palette.dullGray,
        color: theme.palette.white,
        textTransform: 'unset',
        height: '48px',
        borderRadius: '6px',
        marginTop: '40px',
        marginRight: '1vw'
    },
    formStyle: {
        width: '500px',
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        },
    },
    textFieldInput: {
        padding: '14px 20px',
        fontSize: '15px',
        height: '50px',
        boxSizing: 'border-box'
    },
    formControl: {
        width: '100%'
    },
    errorStyle: {
        color: theme.palette.red,
        fontSize: '12px',
        marginBottom: '5px'
    },
    signup: {
        color: theme.palette.white,
        textTransform: 'unset',
    },
    forgot: {
        color: theme.palette.white,
        textTransform: 'unset',
    },
    tokenError: {
        color: theme.palette.errorRed,
        marginBottom: '5px'
    },
    bottomAction: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '500px',
        marginTop: '10px',
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        },
    },
    action: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '500px'
    },
    buttonFlex: {
        display: 'flex',
        justifyContent: 'space-around'
    },
    outerLoader: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '400px'
    },
    progress: {
        color: theme.palette.red,
    },
    rowFlex: {
        display: 'flex',
        flexDirection: 'row',
        height: '100%'
    },
    svg: {
        marginRight: '0.5vw'
    },
    loaderDiv: {
        backgroundColor: theme.palette.dark,
        height: '100%'
    },
    loading: {
        top: '40%',
        right: '45%',
        position: 'fixed',
        color: theme.palette.blue,
    },


    dialog: {
        minWidth: '40vw',
        minHeight: '20vh',
        backgroundColor: 'transparent',
        boxShadow: 'none'
    },
    backdrop: {
        backdropFilter: 'blur(10px)'
    },
    medText: {
        fontSize: '15px',
        color: theme.palette.steelGray
    },
    radioContainer: {
        flexDirection: 'row',
        color: theme.palette.white,
        fontSize: '15px'
    },
    radio: {
        color: theme.palette.white,
        fontSize: '20px'
    },
    activeRadio: {
        color: theme.palette.blue,
        fontSize: '20px'
    },
    saveContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    resendMail: {
        textDecoration: 'underline',
        cursor: 'pointer'
    }

})

export const manageUserStyles = theme => ({
    outerContainer: {
        paddingTop: '4vh',
        display: 'flex',
        justifyContent: 'space-between',
        paddingRight: '2vw',
    },
    heading: {
        fontSize: '28px',
        fontWeight: 300,
        color: theme.palette.coolGray,
        paddingLeft: '2vw',
    },
    table: {
        maxWidth: '99%',
        backgroundColor: theme.palette.dark,
        marginLeft: '2vw',
        marginTop: '3vh'
    },
    tableHeader: {
        color: theme.palette.steelGray,
        fontSize: '13px',
        paddingLeft: '0vw',
        fontWeight: 500,
        paddingRight: '0vw',
        borderColor: 'rgba(149,168,210, 0.12)',

    },
    pagination: {
        display: 'flex'
    },
    icons: {
        cursor: 'pointer'
    },
    noUserMessage: {
        textAlign: 'center',
        display: 'table',
        height: '80%',
        width: '100%'
    },
    docHeader: {
        fontSize: '28px',
        fontWeight: 300,
        color: theme.palette.coolGray,
        paddingLeft: '1.5vw',
    },
    tableData: {
        fontSize: '13px',
        padding: '2vh 0vw',
        paddingLeft: '0px',
        color: theme.palette.white,
        borderColor: 'rgba(149,168,210, 0.12)'
    },
    inactiveTableData: {
        fontSize: '13px',
        padding: '2vh 0vw',
        paddingLeft: '0px',
        color: theme.palette.battleShipGray,
        borderColor: 'rgba(149,168,210, 0.12)',
        pointerEvents: 'none'
    },
    menuItems: {
        fontSize: '13px'
    },
    sortIcons: {
        marginLeft: '8px',
        cursor: 'pointer'
    },
    button: {
        backgroundColor: theme.palette.blue,
        color: theme.palette.white,
        textTransform: 'unset',
        borderRadius: '6px',
        marginTop: '4px',
        height: '40px',
        fontSize: '16px'
    },
    inactiveMore: {
        pointerEvents: 'none',
        color: theme.palette.steelGray
    },
    activeMore: {
        cursor: 'pointer'
    },
    loading: {
        top: '40%',
        right: '45%',
        position: 'fixed'
    },

})
